/** @jsxRuntime classic */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "svgxuse";

import React from "react";
import ReactDOM from "react-dom";
import "./assets/sass/main.sass";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  CbCityGraphQlContextProvider,
  GoogleMapsContextProvider,
} from "./contexts";

const ensureEnv = (value: string | undefined): string => {
  if (value === undefined) {
    throw new Error("Env value missing");
  }
  return value;
};

const googleMapsApiKey = ensureEnv(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

ReactDOM.render(
  <React.StrictMode>
    <GoogleMapsContextProvider googleMapsApiKey={googleMapsApiKey}>
      <CbCityGraphQlContextProvider>
        <App />
      </CbCityGraphQlContextProvider>
    </GoogleMapsContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
